<template>
  <section>
    <nav class="navbar" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <router-link class="navbar-item" to="/">
          <h1 class="title is-5">iamdavidmt</h1>
        </router-link>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" @click.prevent="showMenu()">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="iamdavidmtMenu" class="navbar-menu" :class="{'is-active':this.isMenuVisable}">
        <div class="navbar-start">

          <div class="navbar-item">
            <router-link to="/">Home</router-link>
          </div>

          <div class="navbar-item">
            <router-link to="/blog">Blog</router-link>
          </div>
        </div>

        <div class="navbar-end">
          <div class="navbar-item">
            <Login></Login>
          </div>
          <div class="navbar-item">
            <Logout></Logout>
          </div>

          <div class="navbar-item">
            <Register></Register>
          </div>
        </div>
      </div>
    </nav>
  </section>

</template>

<script>
  import Login from "@/components/Layout/Header/Navigation/Login"
  import Logout from "@/components/Layout/Header/Navigation/Logout"
  import Register from "@/components/Layout/Header/Navigation/Register"

  export default {
    components: {Login, Register,Logout},
    name: "Navigation",
    data() {
      return {
        isMenuVisable: false
      }
    },
    computed: {},
    methods: {
      showMenu() {
        this.isMenuVisable = !this.isMenuVisable;
      }
    }
  }
</script>
<style lang="scss">
</style>